import { render, staticRenderFns } from "./ChemUCI_51LPL6_Q7.vue?vue&type=template&id=d201c8f0&"
import script from "./ChemUCI_51LPL6_Q7.vue?vue&type=script&lang=js&"
export * from "./ChemUCI_51LPL6_Q7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VForm,VSimpleTable})
